import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractInsuranceType from "../InsuranceType";

class InsuranceType extends AbstractInsuranceType {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-insurance-types-ipr';
  }
}

export default InsuranceType;
